import { render, staticRenderFns } from "./HIcon3.vue?vue&type=template&id=0be0acb0&"
import script from "./HIcon3.vue?vue&type=script&lang=js&"
export * from "./HIcon3.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports